import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import { db } from "services/firebase";

const GLOBAL_DEFAULT = {
  version: "global-v1",
  title: "Clinical AI participation consent",
  body:
    "By continuing, you acknowledge that this session uses AI-assisted clinical conversation tools. The AI does not replace your clinician. Your health information is handled according to platform privacy policies.",
};

export async function getRequiredConsents({ tciId, institutionId, patientAge, language }) {
  void tciId;
  void patientAge;
  void language;

  if (institutionId) {
    const configId = `${institutionId}__${tciId || "default"}`;
    const snap = await db.collection("consentConfigurations").doc(configId).get();
    if (snap.exists && snap.data()?.form) {
      return snap.data().form;
    }
  }

  const platformSnap = await db.collection("platformDocuments").doc("global-consent-form").get();
  if (platformSnap.exists && platformSnap.data()?.text) {
    return {
      version: platformSnap.data().version || GLOBAL_DEFAULT.version,
      title: platformSnap.data().title || GLOBAL_DEFAULT.title,
      body: platformSnap.data().text,
    };
  }

  return GLOBAL_DEFAULT;
}

export async function getCmrDataSharingAgreement() {
  const snap = await db.collection("platformDocuments").doc("cmr-data-sharing-agreement").get();
  if (!snap.exists) return null;
  return snap.data();
}

export async function getIpaStatus(institutionId) {
  const callable = firebase.app().functions("us-central1").httpsCallable("getIpaStatus");
  const result = await callable({ institutionId });
  return result.data;
}

export async function submitIpa(payload) {
  const callable = firebase.app().functions("us-central1").httpsCallable("submitIpa");
  const result = await callable(payload);
  return result.data;
}

export async function reviewIpa(payload) {
  const callable = firebase.app().functions("us-central1").httpsCallable("reviewIpa");
  const result = await callable(payload);
  return result.data;
}

export async function listPendingIpas() {
  const callable = firebase.app().functions("us-central1").httpsCallable("listPendingIpas");
  const result = await callable({});
  return result.data;
}
